// extracted by mini-css-extract-plugin
export default {"outlet":"[partnerId]_outlet__W3Ah7","title":"[partnerId]_title__HgqGm"};